import { ObjectHelper } from '../../../../../apps/idl/src/helpers/objectHelper';
import { ENavigationType } from './ENavigationType';

export class NotImplementedNavigationError extends Error {

	constructor(peNavigationType: ENavigationType) {
		super(`La navigation avec '${peNavigationType}' n'est pas prise en charge.`);
		// Nécessaire pour que le 'instanceof NotImplementedNavigationError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, NotImplementedNavigationError);
	}

}